/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { ProductDetailSKUModelType } from '../../../data/product-details.model';
import ProductDetailInfo from '../../molecules/products/ProductDetailInfo';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { getHomepage } from '../../../selectors/generic';
import { getActiveSkuFromVariations } from '../../../selectors/productPage';

const details = [
    { key: 'description', label: 'Description' },
    { key: 'shelfLife', label: 'Shelf life' },
    { key: 'materialNumber', label: 'Product code' },
    { key: 'palletisation', label: 'Palletisation' },
    { key: 'storage', label: 'Storage' },
    { key: 'packaging', label: 'Packaging' },
];

const productDetailRoot = document.getElementById('react-product--details');

const VariationDetail = ({ variations }) => {
    // Handle logic after rendering with Vanilla since elements are out of react
    useEffect(() => {
        const details = findClosestParentWithClass(productDetailRoot, [
            'p-contact-content__tab',
            'tab-pane',
        ]);
        details?.classList.add('active');
        const anchorElement = document.querySelector(
            `a[href="#${details.id}"]`
        );
        anchorElement?.parentNode?.classList.add('active');
    }, []);

    const findClosestParentWithClass = (element, classNames) => {
        if (!element) {
            return null;
        }

        let currentElement = element;

        if (!Array.isArray(classNames)) {
            classNames = [classNames];
        }

        while (currentElement && currentElement.tagName !== 'BODY') {
            if (
                classNames.some((className) =>
                    currentElement.classList.contains(className)
                )
            ) {
                return currentElement;
            }
            currentElement = currentElement.parentElement;
        }

        return null;
    };

    const activeVariation =
        useSelector((state) => getActiveSkuFromVariations(state, variations)) ||
        variations[0];
    const verticalDisplay = useSelector(
        (state) => getHomepage(state).displayProductDetailsVertically || false
    );

    return ReactDOM.createPortal(
        activeVariation && (
            <div
                className={
                    'product-details__list row' +
                    (verticalDisplay ? ' vertical' : '')
                }
            >
                {details.map(({ key, label }) => (
                    <ProductDetailInfo
                        key={key}
                        label={label}
                        value={activeVariation[key]}
                    />
                ))}
                {(activeVariation?.extraLabel ?? []).map(({ value, label }) => (
                    <ProductDetailInfo
                        key={label}
                        label={label}
                        value={value}
                    />
                ))}
            </div>
        ),
        productDetailRoot
    );
};

VariationDetail.propTypes = {
    variation: PropTypes.arrayOf(PropTypes.shape(ProductDetailSKUModelType)),
};

export default VariationDetail;
